<template>
  <b-navbar toggleable="lg" variant="white" class="mt-0 nav-shadow">
    <div class="icon-wrapper clickable" @click="toggleMenu">
      <i class="mdi mdi-menu"></i>
    </div>
    <b-navbar-brand :to="{ name: 'dashboard' }">
      <img
        src="../../assets/logos/logo_inline.svg"
        class="logo pl-2"
        alt="Logo TeamCulture"
      />
    </b-navbar-brand>
  </b-navbar>
</template>
<!--  -->
<script>
export default {
  props: ['toggleMenu'],
}
</script>

<style scoped lang="scss">
.icon-wrapper {
  display: inline-block;
  height: 44px;
  width: 44px;
}

.logo {
  width: 190px;
  height: 35px;
}

.nav-shadow {
  box-shadow: 0 3px 6px rgba(221, 221, 221, 0.18);
}
</style>
